const ITEMS = ["Reaching the Lost", "Teaching the Believers", "Empowering Disciples", "Victory as a Way of Life"];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-white/10 bg-[#0a0a0a] py-6"
      aria-hidden="true"
    >
      <div className="animate-marquee flex whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="font-display uppercase tracking-tight text-2xl md:text-4xl text-zinc-600 mx-6 flex items-center gap-12"
              >
                {item}
                <span className="text-[#4169E1] text-xl md:text-2xl">&#10022;</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
